import { render, staticRenderFns } from "./PerformerEventItem.vue?vue&type=template&id=0f863f5d&scoped=true&"
import script from "./PerformerEventItem.vue?vue&type=script&lang=js&"
export * from "./PerformerEventItem.vue?vue&type=script&lang=js&"
import style0 from "./PerformerEventItem.vue?vue&type=style&index=0&id=0f863f5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f863f5d",
  null
  
)

export default component.exports